import { Outlet } from 'react-router-dom';
import './styles.css';

export const GotphotoLayout = (props) => {
    return (
        <>
            {
                (props.children === undefined) ? <Outlet/> : props.children
            }
        </>
    );
}
